import { createFileRoute, redirect } from '@tanstack/react-router'

/** URL เดิม /admin/size — รีไดเรกต์ไปหน้า picklist (แท็บขนาดถูกถอนออกแล้ว) */
export const Route = createFileRoute('/(dashboard)/admin/size')({
  beforeLoad: () => {
    throw redirect({
      to: '/admin/picklist',
      search: { tab: 'durian_type' },
    })
  },
  component: () => null,
})
